<template>
    <div class="app_footer">
        <section class="main_section section_contact nomargin" id="SectionContact">
            <div class="section_content">
                <div class="content_text">
                    <div class="text_title">Contact us</div>
                    <div class="text_questions">
                        <div class="text_question">Have a question?</div>
                        <div class="text_question">A comment?</div>
                        <div class="text_question">Want to know more about The Atlas of the Offshore World?</div>
                    </div>
                    <div class="text_more">
                        The staff at the International Tax Observatory is there to answer your question! Register now to join our weekly online Question Hour where you can speak directly with our staff.
                    </div>
                </div>
                <a class="content_extlink" href="https://airtable.com/shrIDppNLWSCVhbI0" target="_blank">
                    <span>Register now to join our Question Hour sessions</span>
                </a>
            </div>
        </section>
        <section class="main_section section_footer">
            <div class="section_content">
                <div class="footer_col" data-col="logos">
                    <div class="col_logo" data-logo="ito"></div>
                    <div class="col_logo" data-logo="skat"></div>
                </div>
                <div class="footer_col">
                    <nuxt-link class="footer_link" to="/">Homepage</nuxt-link>
                    <a class="footer_link" @click="clickMenuItem('dataset')">Datasets</a>
                    <a class="footer_link" @click="clickMenuItem('country')">Countries</a>
                    <nuxt-link class="footer_link" to="/download-data/">Download data & methodology</nuxt-link>
                </div>
                <div class="footer_col">
                    <div class="col_title">MORE</div>
                    <nuxt-link class="footer_link" to="/research-briefs">Research briefs</nuxt-link>
                    <nuxt-link class="footer_link" to="/about/">About</nuxt-link>
                </div>
                <div class="footer_col">
                    <a class="footer_link" @click="openCookies()">Cookies settings</a>
                    <nuxt-link to="/privacy-policy/" class="footer_link">Privacy policy</nuxt-link>
                    <div class="col_watermark">©EUTO 2021</div>
                </div>
                <div class="footer_col" data-col="share">
                    <div class="col_title">FOLLOW US ON</div>
                    <div class="col_icons">
                        <a class="col_icon" href="https://www.facebook.com/people/EU-Tax-Observatory/100075536903031/" target="_blank" data-icon="fb"></a>
                        <!--<a class="col_icon" data-icon="in"></a>-->
                        <a class="col_icon" data-icon="tw" href="https://twitter.com/taxobservatory" target="_blank"></a>
                        <a class="col_icon" data-icon="lk" href="https://www.linkedin.com/company/eu-tax-observatory/" target="_blan"></a>
                    </div>
                </div>

                <a class="footer_wdd" href="https://wedodata.fr/" target="_blank"></a>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    props: {
        page: {
            default: function () {
                return 'home'
            }
        }
    },
    data: function () {
        return {
        }
    },
    mounted: function () {
        this.displayMobileMenu = false;
    },
    methods: {
        openCookies: function (){
            document.querySelector("#CookieConsentBlock").setAttribute("data-displayed", "displayed");
        },

        clickMenuItem: function (type){
            this.$emit('headerMenuClicked', type);
        },
    }
}
</script>

<style lang="scss" scoped>
@import "~assets/scss/_variables.scss";
@import "~assets/scss/_browsers.scss";

.app_footer{
    position: relative;
    left: 0px;
    top: 0px;
    height: 517px;
    width: 100%;
    background: $colorBlack;
    color: #fff;
    text-align: center;

    .section_contact{
        height: 275px;
        background: $colorOrange;
        padding: 30px 0 60px;
        text-align: center;
        position: relative;
        overflow: hidden;
        &:before{
            /*
            content: "";
            position: absolute;
            right: 0px;
            top: 0px;
            background: url("/images/visual-asset-contact.png") no-repeat 0 0;
            background-size: 100% 100%;
            width: 1250px;
            height: 275px;
            */
        }
        .section_content{
            display: inline-block;
            vertical-align: top;
            max-width: 1280px;
            width: 100%;
            text-align: left;
            padding: 0 180px;
            .content_extlink{
                position: absolute;
                right: 100px;
                width: 360px;
                border-radius: 32px;
                top: 40px;
                background: $colorBlack;
                color: #fff;
                text-decoration: none;
                height: 32px;
                cursor: pointer;
                line-height: 32px;
                font-size: 14px;
                padding: 0 20px;
                &:after{
                    content: "";
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translate(0, -50%);
                    background: url("/images/persona.svg") no-repeat 0 0;
                    background-size: 100% 100%;
                    width: 20px;
                    height: 20px;
                }
                &:hover{
                    background: $colorBlueHover;
                }
            }
            .content_text{
                position: relative;
                max-width: 545px;
                .text_title{
                    font-size: 32px;
                    font-weight: 700;
                    color: $colorBlack;
                }
                .text_questions{
                    margin-top: 10px;
                    .text_question{
                        display: block;
                        color: #164193;
                        font-size: 14px;
                        line-height: 20px;
                    }
                }
                .text_more{
                    font-size: 18px;
                    line-height: 24px;
                    font-weight: 500;
                    color: $colorBlack;
                    margin-top: 10px;
                }
            }
        }
    }

    .section_footer{
        height: 242px;
        padding: 40px 0 60px;
        .section_content{
            position: relative;
            display: inline-block;
            vertical-align: top;
            max-width: 1280px;
            width: 100%;
            text-align: left;
            padding: 0 60px;
            .footer_col{
                display: inline-block;
                vertical-align: top;
                margin-right: 40px;
                width: 120px;
                &[data-col="logos"]{
                    width: 370px;
                    margin-right: 20px;
                    .col_logo{
                        float: left;
                    }
                }
                .col_logo{
                    &[data-logo="ito"]{
                        background: url("/images/ito-white.png") no-repeat 0 0;
                        background-size: 100% 100%;
                        width: 135px;
                        height: 75px;
                        position: relative;
                        &:after{
                            content: "";
                            position: absolute;
                            right: -6px;
                            width: 1px;
                            height: 100%;
                            background: #fff;
                        }
                    }
                    &[data-logo="skat"]{
                        background: url("/images/skatteforsk-white.png") no-repeat 0 0;
                        background-size: 100% 100%;
                        width: 232px;
                        height: 95px;
                        position: relative;
                        top: -6px;
                    }
                }
                &[data-col="share"]{
                    width: 160px;
                }
                .col_title{
                    color: #BAC6DF;
                    text-transform: uppercase;
                    margin-bottom: 14px;
                    letter-spacing: 1.2px;
                }
                .footer_link{
                    display: block;
                    color: #fff;
                    cursor: pointer;
                    text-decoration: none;
                    font-size: 12px;
                    line-height: 14px;
                    margin-bottom: 14px;
                    letter-spacing: 1.2px;
                    &:hover{
                        opacity: .5;
                    }
                }
            }
            .footer_wdd{
                position: absolute;
                right: 60px;
                top: 0px;
                background: url("/images/logo-wdd.png") no-repeat 0 0;
                background-size: 100% 100%;
                width: 92px;
                height: 162px;
                &:hover{
                    opacity: .5;
                }
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// components/appFooter.vue